/* eslint-disable camelcase */
import { useMemo, useContext } from 'react';
// import ReactEcharts from 'echarts-for-react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
import Head from '@/containers/chart_box/Head';
import Body from '@/containers/chart_box/Body';
import { fmtThousand } from '@/utils/comUtil';
// import webStorage from '@/utils/storageManager';
import dayjs from 'dayjs';
import { sinTimeDimensionMulIndexMulValue } from '@/utils/reportResponseUtil';

import { LineChart } from 'echarts/charts';
import {
  // GridSimpleComponent,
  // GridComponent,
  // PolarComponent,
  // RadarComponent,
  // GeoComponent,
  // SingleAxisComponent,
  // ParallelComponent,
  // CalendarComponent,
  // GraphicComponent,
  // ToolboxComponent,
  // TooltipComponent,
  // AxisPointerComponent,
  // BrushComponent,
  TitleComponent,
  // TimelineComponent,
  // MarkPointComponent,
  // MarkLineComponent,
  // MarkAreaComponent,
  // LegendComponent,
  // LegendScrollComponent,
  // LegendPlainComponent,
  // DataZoomComponent,
  // DataZoomInsideComponent,
  // DataZoomSliderComponent,
  // VisualMapComponent,
  // VisualMapContinuousComponent,
  // VisualMapPiecewiseComponent,
  // AriaComponent,
  // TransformComponent,
  // DatasetComponent,
} from 'echarts/components';
import {
  CanvasRenderer,
  // SVGRenderer,
} from 'echarts/renderers';
import { useIntl } from 'umi';

echarts.use([TitleComponent, CanvasRenderer, LineChart]);

// 图表容器样式与坐标轴格式化函数提到模块级，保证引用稳定，
// 避免 ReactEChartsCore 因为 props 引用变化而重复 setOption
const CHART_STYLE = { width: '100%', height: '100%' };
const fmtAxisThousand = (p) => {
  return fmtThousand(p);
};

const AcUsr = (props) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);
  const intl = useIntl();
  // eslint-disable-next-line no-unused-vars
  const { formatMessage } = intl;
  const { charts } = themeContext[brandContext];
  const { chartsFontSize, fontFamily } = themeContext.comm;
  const { data, title, loading } = props;

  // 渲染阶段直接计算 option，图表挂载时拿到的就是完整配置，
  // 避免先挂载空 option 再由 effect 补一次而绘制两遍
  const chartOption = useMemo(() => {
    // const DICTOBJ = webStorage.get('DICTOBJ');
    // const legendDataUnuse = [];
    // const legendData = [];
    let xData = [];
    // let series = [];
    let activeMember = [];
    let vipActiveMember = [];
    const result = sinTimeDimensionMulIndexMulValue(data || []);
    for (let index = 0; index < 24; index++) {
      xData.push(
        dayjs('1970-00-00', 'YYYY-MM-DD').add(index, 'hour').format('HH'),
      );
    }
    // legendDataUnuse.forEach((code) => {
    //   (DICTOBJ?.identity_type || []).forEach((item) => {
    //     if (code === item.dictCode) {
    //       legendData.push(item.dictName);
    //     }
    //   });
    // });
    xData.forEach((e) => {
      // const activeMemberItem = result?.find((s) => s.LABEL === e) || {
      //   VALUE: 0,
      // };
      // activeMember.push(activeMemberItem.VALUE);
      const activeMemberItem = result?.['ACTIVE_MEMBER']?.find(
        (s) => s.LABEL === e,
      ) || {
        VALUE: 0,
      };
      activeMember.push(activeMemberItem.VALUE);
      const vipActiveMemberItem = result?.['VIP_ACTIVE_24H']?.find(
        (s) => s.LABEL === e,
      ) || {
        VALUE: 0,
      };
      vipActiveMember.push(vipActiveMemberItem.VALUE);
    });
    // series.push({
    //   name: '天猫',
    //   type: 'line',
    //   data: activeMember,
    //   smooth: true,
    // });

    const seriesData = [
      {
        name: '活跃会员数',
        // name: formatMessage({ id: 'ec.dashboard.n07.lbl03' }),
        type: 'line',
        data: activeMember,
        // yAxisIndex: 0,
        smooth: true,
      },
      {
        name: 'VIP活跃会员数',
        // name: formatMessage({ id: 'ec.dashboard.n07.lbl02' }),
        type: 'line',
        // yAxisIndex: 1,
        data: vipActiveMember,
        smooth: true,
      },
    ];

    let option = {
      textStyle: {
        fontSize: chartsFontSize.s03,
        fontFamily: fontFamily,
      },
      tooltip: {
        // formatter: (params) => {
        //   let item = params[0];
        //   let vipItem = params[1];
        //   let res = `${params[0].name}: 00 <br />`;
        //   res += `${item.marker}${item.seriesName} ${item.value}<br />`;
        //   res += `${vipItem.marker}${vipItem.seriesName} ${vipItem.value}`;
        //   return res;
        // },
        trigger: 'axis',
        textStyle: {
          fontSize: chartsFontSize.s03,
          fontWeight: 'bold',
        },
      },
      legend: {
        // data: ['天猫', '京东', '小程序', '门店'],
        // data: legendData,
        data: ['活跃会员数', 'VIP活跃会员数'],
        itemWidth: 10,
        itemHeight: 10,
        top: 0,
        icon: 'rect',
      },
      grid: {
        top: 30,
        left: 10,
        right: 10,
        bottom: 0,
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: xData, //['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
        axisLabel: {
          color: charts.xColor, //坐标值得具体的颜色
          fontSize: chartsFontSize.s03,
          //   interval: function () {
          //     return true;
          //   },
        },
        axisTick: false,
        axisLine: {
          lineStyle: {
            color: charts.axisLineColor,
          },
        },
      },
      yAxis: {
        type: 'value',
        axisTick: false,
        axisLine: false,
        axisLabel: {
          color: charts.yColor, //坐标值得具体的颜色
          fontSize: chartsFontSize.s03,
          formatter: fmtAxisThousand,
        },
        minInterval: 1,
        splitLine: {
          show: true, //去除网格线
          lineStyle: {
            color: charts.axisLineColor, //坐标线的颜色
          },
        },
        // name: '人',
        // nameRotate: 45,
        nameGap: 15,
        nameTextStyle: {
          // color: color.black0100,
          padding: [0, 35, 0, 0],
        },
        min: 0,
      },
      color: charts.lineColorAreaList,
      series: seriesData,
      // series: series,
    };
    return option;
  }, [
    data,
    chartsFontSize.s03,
    fontFamily,
    charts.xColor,
    charts.axisLineColor,
    charts.yColor,
    charts.lineColorAreaList,
  ]);

  return (
    <>
      <Head boxId={title}></Head>
      <Body bizData={data} loading={loading}>
        {/* <div className={styles.box}>
          <div className={styles.TypeChangeBtnGroup}>
            <TypeChangeBtnGroup
              change={changeType}
              typeList={[
                { label: {formatMessage({ id: 'comm.period.lbl02' })}, value: 'week' },
                { label: {formatMessage({ id: 'comm.period.lbl03' })}, value: 'month' },
              ]}
            />
          </div>
        </div> */}
        <ReactEChartsCore
          echarts={echarts}
          lazyUpdate={true}
          option={chartOption}
          notMerge={true}
          style={CHART_STYLE}
          showLoading={false}
        />
        {/* <ReactEcharts
          style={{ width: '100%', height: '100%' }}
          option={echartsOptions || {}}
          notMerge={true}
          lazyUpdate={true}
          showLoading={false}
          // onEvents={onEvents}
        /> */}
      </Body>
    </>
  );
};
export default AcUsr;
